export default {
  mounted() {
    const copyButton = document.getElementById(this.el.dataset.copyButton)
    const richText = this.el

    const successMessage = richText.dataset.successMessage ?? 'Copied!'
    const notifySuccess = () => this.pushEvent('trigger_flash', { type: 'success', message: successMessage })

    copyButton.addEventListener('click', function () {
      richText.setAttribute('contenteditable', 'true')
      // Focus on the contenteditable element
      richText.focus()

      const range = document.createRange()
      range.selectNodeContents(richText)
      window.getSelection().removeAllRanges()
      window.getSelection().addRange(range)

      try {
        // Why the two implementations (execCommand vs navigator.clipboard)?
        //
        // execCommand is deprecated and not supported at all in Safari, but its 
        // implementation is *way* nicer. (The result of copying things like HTML
        // tables is way more understandable than the plain-text version of the HTML.)
        const successful = document.execCommand('copy')

        if (successful) {
          console.log('Rich text copied to clipboard!')
          notifySuccess()
        } else {
          const blob = new Blob([richText.innerHTML], { type: 'text/html' })

          navigator.clipboard
            .write([new ClipboardItem({ 'text/html': blob, 'text/plain': richText.innerText })])
            .then(
              notifySuccess,
              () => { console.error('Failed to copy text via clipboard.write.') }
            )
        }
      } catch (err) {
        console.error('Unable to copy rich text:', err)
      }

      richText.removeAttribute('contenteditable')
      window.getSelection().removeAllRanges()
    })
  },
}
